module.exports = __webpack_public_path__ + "static/img/11.49967b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/11.png
// module id = uq0c
// module chunks = 0